export type * as _SolidState from "./_model";
import { default as create } from "./create";
import { default as createAsync } from "./create-async";
import * as helpers from "./helpers";
// TODO: change logic to use nanostores for everything, but keep the interface the same
export const solidstate = {
  helpers,
  create,
  createAsync,
};
